import { clubbiStyled } from 'clubbi-ui'

export const StyledContainer = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '40px 20px',
  height: '100%',
  boxSizing: 'border-box',
  background: theme.palette.brandWhite.main,
}))

export const StyledTitle = clubbiStyled('h2')(({ theme }) => ({
  fontSize: '30px',
  fontWeight: '700',
  marginBottom: '20px',
  color: theme.palette.brandPurple.main,
}))

export const StyledDescription = clubbiStyled('p')(({ theme }) => ({
  fontSize: '18px',
  color: theme.palette.brandGrey[100],
  lineHeight: '28px',
  margin: 0,
}))

export const StyledCloseButton = clubbiStyled('button')(({ theme }) => ({
  marginTop: '15px',
  padding: '6px 20px',
  backgroundColor: theme.palette.brandPurple[60],
  color: theme.palette.brandWhite.main,
  border: 'none',
  borderRadius: '4px',
  fontWeight: '700',
  cursor: 'pointer',
  fontSize: theme.typography.fontSizeXS,
  transition: 'background-color 0.2s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  marginBottom: '10px',
}))
